import React, { useState } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate, useParams } from "react-router";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import PageLayout from "../../../Components/Layout/FinancePageLayout";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { SearchFilter } from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import { FormatStatus } from "../../../../../utils/functions/FormatStatus";

function CostCenterExpenseDetails({ route }) {
  const data = useParams();
  const formattedData = JSON.parse(data?.data);
  const [search, setSearch] = useState("");
  const filteredData = formattedData?.filter((item) =>
    item?.paymentName?.toLowerCase().includes(search?.toLowerCase())
  );
  const navigate = useNavigate();

  let currentHeaders = [
    {
      title: "Payment Type",
      key: "PaymentTypeName",
    },
    {
      title: "Batch Id",
      key: "batchId",
    },
    {
      title: "Narration",
      key: "narration",
    },
    {
      title: "Amount Spent",
      key: "AmountSpent",
    },
    {
      title: " Created Date",
      key: "createdDate",
    },
    {
      title: "Approval Status",
      key: "ApprovalStatus",
    },
    {
      title: "Payment Date",
      key: "PaymentDate",
    },
    // {
    //   title: "Account Number",
    //   key: "AccountNumber",
    // },
    {
      title: "Cost Amount",
      key: "costAmount",
    },
  ];
  let backBtn = (
    <div>
      <button
        onClick={() => navigate(-1)}
        className={`rounded-lg border-solid border-[1px] border-[#A0BDA2] p-4 py-3 flex space-x-[10px] text-[#4B664C] text-[13px] font-[600]`}
      >
        <IoArrowBackOutline className={`text-[20px]`} />
        <p>Back</p>
      </button>
    </div>
  );

  // const handleSearch = (e) => {
  //   setSearch(e.target.value);
  // };

  return (
    <RouteLayout>
      <PageLayout title={"Cost Center Expense Details"} backBtn={backBtn}>
        <div className="mb-[40px]">
          {/* <SearchFilter text={search} onChange={handleSearch} /> */}
          <SearchFilter
            text={(value) => setSearch(value)}
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
        </div>
        <Table className="!w-full">
          <thead>
            {currentHeaders.map((header, i) => (
              <th key={i + 1}>
                <p className="!text-[#29382A] text-[11px]">{header.title}</p>
              </th>
            ))}
          </thead>
          <tbody>
            {filteredData.map((item, _index) => (
              <tr>
                <td>
                  <p className="text-[11px]">{item?.paymentName}</p>
                </td>
                <td>
                  <p className="text-[11px]">{item?.batchId}</p>
                </td>
                <td>
                  <p className="text-[11px]">{item?.narration}</p>
                </td>

                <td>
                  <p className="text-[11px]">
                    {FormatCurrency(item?.amountSpent)}
                  </p>
                </td>
                <td>
                  <p className="text-[11px]">
                    {FormatDateTime(item?.createdDate)}
                  </p>
                </td>
                <td className="text-[11px]">
                  {FormatStatus(item?.approvalStatus)}
                </td>
                <td>
                  <p className="text-[11px]">
                    {FormatDateTime(item?.createdDate)}
                  </p>
                </td>
                {/* <td>
                  <p className="text-[11px]"> {item.accountNumber}</p>
                </td> */}
                <td>
                  <p className=" text-[11px]">
                    {FormatCurrency(item.costAmount)}
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </PageLayout>
    </RouteLayout>
  );
}

export default CostCenterExpenseDetails;
